// ============================================================================
// Admin Dashboard API Configuration
// ============================================================================
// Two-VPS Production Architecture:
// - DataFeed Server (VPS 1): Tick storage, BetaSpread, Admin auth
// - FixEngine Server (VPS 2): LP connections, Symbol management, Market data
//
// Symbol data flow: Admin Dashboard → DataFeed Symbol Proxy → FixEngine
// ============================================================================

// DataFeed Server API (internal - same VPS as admin dashboard)
// Handles: Authentication, BetaSpread, Tick storage, Symbol proxy
export const dataFeedURL = process.env.REACT_APP_DATAFEED_URL || 'http://localhost:5100';

// FixEngine API (external - different VPS)
// Handles: LP connections, Symbol management, Market subscriptions
// Note: In production, symbols are accessed via DataFeed Symbol Proxy (not directly)
export const fixEngineURL = process.env.REACT_APP_FIXENGINE_URL || 'http://localhost:7261';

// Legacy backward compatibility (deprecated - use dataFeedURL instead)
export const baseURL = dataFeedURL;

// ============================================================================
// API Endpoints
// ============================================================================
// DataFeed Server endpoints
export const adminAuthEndpoint = 'api/admin/auth';  // Admin Dashboard authentication
export const betaSpreadEndpoint = 'api/betaspread';  // BetaSpread calculation & configuration
export const subscriptionsEndpoint = 'api/subscriptions';  // DataFeed subscription management
export const backfillEndpoint = 'api/backfill';  // CSV upload & backfill
export const gapsEndpoint = 'api/gaps';  // Gap detection & filling

// Symbol Proxy endpoint (DataFeed proxies to FixEngine)
export const symbolsEndpoint = 'api/symbols';  // Symbol list & management (proxied to FixEngine)
